import { Button } from "@/components/ui/button";

type PaymentButtonProps = {
  amount: number;
  currency?: string;
  compensationId: string;
  disabled?: boolean;
  children?: React.ReactNode;
  variant?: "default" | "link";
};

export default function PaymentButton(props: PaymentButtonProps) {
  const {
    amount,
    currency = "PLN",
    compensationId,
    disabled,
    children,
    variant = "default",
  } = props;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      window.confirm(
        "Wyrażam zgodę na dostarczenie treści cyfrowych przed upływem terminu do odstąpienia od umowy i przyjmuję do wiadomości, że z chwilą dostarczenia tych treści utracę w związku z tym przysługujące mi prawo do odstąpienia od umowy, zgodnie z Regulaminem P4D."
      )
    ) {
      e.currentTarget.submit();
    }
  };

  return (
    <form
      action="https://vprevfbwpggljbrnmscq.supabase.co/functions/v1/payments"
      method="POST"
      onSubmit={handleSubmit}
      className="flex gap-2 items-center"
    >
      <input type="hidden" name="amount" value={amount} />
      <input type="hidden" name="currency" value={currency} />
      <input type="hidden" name="compensationId" value={compensationId} />
      <Button
        size="sm"
        variant={variant}
        type="submit"
        disabled={disabled}
        className="px-2 w-full font-bold text-lg"
      >
        {children}
      </Button>
    </form>
  );
}
